/**
 * Generic percentage operations.
 */

export function percentOfNumber(pct: number, n: number): number {
  return (pct / 100) * n;
}

export function whatPercent(part: number, whole: number): number {
  if (!whole) return 0;
  return (part / whole) * 100;
}

export function percentChange(from: number, to: number): number {
  if (!from) return 0;
  return ((to - from) / from) * 100;
}

export function addPercent(n: number, pct: number): number {
  return n + n * (pct / 100);
}

export function subtractPercent(n: number, pct: number): number {
  return n - n * (pct / 100);
}

/** Reverse: "X% of WHAT is Y" -> Y / (X/100). */
export function reverseOf(pct: number, partial: number): number {
  if (!pct) return 0;
  return partial / (pct / 100);
}
